import type { ConnectionRepository } from '#/domain/connection/ConnectionRepository'
import type { Connection } from '#/domain/connection/Connection'
import type { NewConnection } from '#/domain/connection/NewConnection'
import type { HttpClientPort } from '#/infrastructure/persistence/HttpClientPort'
import { objectToFormData } from '#/infrastructure/persistence/objectToFormData'
import { toDomainList, type ConnectionResponseDto } from './ConnectionDto'

export class HttpConnectionRepository implements ConnectionRepository {
  constructor(private readonly http: HttpClientPort) {}

  async findAll(): Promise<Connection[]> {
    const raw = await this.http.get<ConnectionResponseDto[]>('auth0/organization/connection')
    return toDomainList(raw)
  }

  create(connection: NewConnection): Promise<void> {
    return this.http.post<void>('auth0/connection/sso', { body: objectToFormData(connection) })
  }
}
